<div class="action-tablet-transport-creation-profile-details" (click)="profileClicked()">
    <sc-padding>
        <sc-flex [centered]="true">
            {{transportCreationProfile?.displayName}}
        </sc-flex>
    </sc-padding>
</div>
